import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GraduationCap, ChevronRight, Award } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const STATUS_COLOR = {
  "NOT STARTED": "text-gray-400 border-white/15",
  "IN TRAINING": "text-[#E4C987] border-[#C9A45C]/40",
  "ASSESSMENT PENDING": "text-blue-300 border-blue-400/40",
  COMPLETED: "text-emerald-400 border-emerald-500/40",
};

export default function ApplicatorTraining() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/applicator/training").then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data) return <div className="text-gray-500">Loading…</div>;

  const groups = {};
  (data.courses || []).forEach((c) => { (groups[c.category] = groups[c.category] || []).push(c); });

  return (
    <div data-testid="applicator-training-page">
      <div className="flex items-center gap-3 mb-1"><GraduationCap className="text-[#C9A45C]" size={26} /><h1 className="serif-head text-3xl lg:text-4xl">{t("my_training")}</h1></div>
      <p className="text-[11px] text-gray-600 mb-6">DEMO / PLACEHOLDER training content — replace with ERRĀH approved material.</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-8" data-testid="training-summary">
        {[[t("courses_in_progress"), data.in_progress], [t("assessments_pending"), data.assessments_pending], [t("certificates"), data.certificates], ["Courses", (data.courses || []).length]].map(([l, v]) => (
          <div key={l} className="hair-border bg-white/[0.02] p-4"><p className="errah-label mb-1">{l}</p><p className="font-display text-2xl gold-text">{v}</p></div>
        ))}
      </div>

      {Object.entries(groups).map(([cat, courses]) => (
        <div key={cat} className="mb-8">
          <p className="errah-label gold-text mb-3">{cat}</p>
          <div className="space-y-2">
            {courses.map((c) => (
              <button key={c.service_id} onClick={() => navigate(`/applicator/training/${c.service_id}`)}
                data-testid={`course-row-${c.service_id}`}
                className="w-full hair-border bg-white/[0.02] p-4 flex items-center gap-4 hover:bg-white/[0.05] transition-colors text-left">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <p className="text-sm truncate">{c.service_name}</p>
                    {c.cert_status === "CERTIFIED" && <Award size={14} className="text-emerald-400 shrink-0" />}
                  </div>
                  <div className="mt-2 h-1.5 bg-white/10 rounded-full overflow-hidden max-w-[280px]">
                    <div className="h-full bg-[#C9A45C]" style={{ width: `${c.progress_pct}%` }} />
                  </div>
                  <p className="text-[11px] text-gray-500 mt-1">{c.completed_modules}/{c.total_modules} {t("module")}s · {c.progress_pct}%</p>
                </div>
                <span className={`text-[10px] px-2.5 py-1 border shrink-0 ${STATUS_COLOR[c.status] || STATUS_COLOR["NOT STARTED"]}`}>{c.status}</span>
                <ChevronRight size={16} className="text-gray-600 shrink-0" />
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
